// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, formDataBodySerializer } from '@hey-api/client-axios';
import type { RootData, ListHeroesApiTestingOnlyData, ListHeroesApiTestingOnlyResponse, CreateHeroApiTestingOnlyData, CreateHeroApiTestingOnlyResponse, CreateHeroApiTestingOnlyError, SsotSsotSsotData, SsotSsotSsotResponse, GetMindstringPrototypesApiSsotSsotData, GetMindstringPrototypesApiSsotSsotResponse, HealthCheckHealthData, PostOriginApiCrudData, PostOriginApiCrudResponse, PostOriginApiCrudError, GetOriginsApiCrudData, GetOriginsApiCrudResponse, GetOriginsApiCrudError, PutOriginApiCrudData, PutOriginApiCrudResponse, PutOriginApiCrudError, DeleteOriginsApiCrudData, DeleteOriginsApiCrudResponse, DeleteOriginsApiCrudError, PostSituationApiCrudData, PostSituationApiCrudResponse, PostSituationApiCrudError, GetSituationsApiCrudData, GetSituationsApiCrudResponse, GetSituationsApiCrudError, PutSituationApiCrudData, PutSituationApiCrudResponse, PutSituationApiCrudError, DeleteSituationsApiCrudData, DeleteSituationsApiCrudResponse, DeleteSituationsApiCrudError, GetThoughtsApiCrudData, GetThoughtsApiCrudResponse, GetThoughtsApiCrudError, IngestThoughtsApiCrudData, IngestThoughtsApiCrudResponse, IngestThoughtsApiCrudError, ConfirmThoughtsApiCrudData, ConfirmThoughtsApiCrudResponse, ConfirmThoughtsApiCrudError, DeleteThoughtsApiCrudData, DeleteThoughtsApiCrudResponse, DeleteThoughtsApiCrudError, GetTargetsApiCrudData, GetTargetsApiCrudResponse, GetTargetsApiCrudError, PostTargetApiCrudData, PostTargetApiCrudResponse, PostTargetApiCrudError, PutTargetApiCrudData, PutTargetApiCrudResponse, PutTargetApiCrudError, DeleteTargetsApiCrudData, DeleteTargetsApiCrudResponse, DeleteTargetsApiCrudError, GetProfileApiCrudData, GetProfileApiCrudResponse, GetActiveUsersApiCrudData, GetActiveUsersApiCrudResponse, GetRolesApiCrudData, GetRolesApiCrudResponse, GetRolesApiCrudError, GetMoveonApiCrudData, GetMoveonApiCrudResponse, GetMoveonApiCrudError, GetTopicsApiCrudData, GetTopicsApiCrudResponse, GetTopicsApiCrudError, IngestTopicsApiCrudData, IngestTopicsApiCrudResponse, IngestTopicsApiCrudError, PutTopicApiCrudData, PutTopicApiCrudResponse, PutTopicApiCrudError, DeleteTopicsApiCrudData, DeleteTopicsApiCrudResponse, DeleteTopicsApiCrudError, GetCriteriaApiCrudData, GetCriteriaApiCrudResponse, GetCriteriaApiCrudError, IngestCriteriaApiCrudData, IngestCriteriaApiCrudResponse, IngestCriteriaApiCrudError, DeleteCriteriaApiCrudData, DeleteCriteriaApiCrudResponse, DeleteCriteriaApiCrudError, GetVersionsApiCrudData, GetVersionsApiCrudResponse, GetVersionsApiCrudError, PostVersionApiCrudData, PostVersionApiCrudResponse, PostVersionApiCrudError, PutVersionApiCrudData, PutVersionApiCrudResponse, PutVersionApiCrudError, ExtendVersionApiCrudData, ExtendVersionApiCrudResponse, ExtendVersionApiCrudError, DeleteVersionsApiCrudData, DeleteVersionsApiCrudResponse, DeleteVersionsApiCrudError, ExposeTypesApiCrudSsotData, ExposeTypesApiCrudSsotResponse, ExtractThoughtsApiServiceData, ExtractThoughtsApiServiceResponse, ExtractThoughtsApiServiceError, ExtractCriteriaApiServiceData, ExtractCriteriaApiServiceResponse, ExtractCriteriaApiServiceError, CreateAssessmentFeedbackApiServiceData, CreateAssessmentFeedbackApiServiceResponse, CreateAssessmentFeedbackApiServiceError, CreateFeedbackCollectionApiServiceData, CreateFeedbackCollectionApiServiceResponse, CreateFeedbackCollectionApiServiceError, RevokeFeedbackCollectionApiServiceData, RevokeFeedbackCollectionApiServiceResponse, RevokeFeedbackCollectionApiServiceError, ListFeedbackCollectionLinksApiServiceData, ListFeedbackCollectionLinksApiServiceResponse, GetPublicFeedbackFormApiServiceData, GetPublicFeedbackFormApiServiceResponse, GetPublicFeedbackFormApiServiceError, SubmitPublicFeedbackApiServiceData, SubmitPublicFeedbackApiServiceResponse, SubmitPublicFeedbackApiServiceError, TranscribePublicFeedbackApiServiceData, TranscribePublicFeedbackApiServiceResponse, TranscribePublicFeedbackApiServiceError, InterpretThoughtApiExperimentData, InterpretThoughtApiExperimentResponse, InterpretThoughtApiExperimentError, OcrBusinesscardApiExperimentData, OcrBusinesscardApiExperimentError, OcrBusinesscardDataApiExperimentData, OcrBusinesscardDataApiExperimentResponse, OcrBusinesscardDataApiExperimentError, SsotExperimentSsotData, SsotExperimentSsotResponse, OcrImageApiServiceData, OcrImageApiServiceResponse, OcrImageApiServiceError, ReportStatsApiServiceData, ReportStatsApiServiceResponse, BuildQuestionnaireApiServiceData, BuildQuestionnaireApiServiceResponse, BuildQuestionnaireApiServiceError, SetReflectionApiServiceData, SetReflectionApiServiceResponse, SetReflectionApiServiceError, ResetReflectionsApiServiceData, ResetReflectionsApiServiceResponse, ResetReflectionsApiServiceError, TranscribeAudioApiServiceData, TranscribeAudioApiServiceResponse, TranscribeAudioApiServiceError, UploadOriginApiServiceData, UploadOriginApiServiceResponse, UploadOriginApiServiceError, UpdateSituationConfigApiServiceData, UpdateSituationConfigApiServiceResponse, UpdateSituationConfigApiServiceError, ResetSituationsConfigsApiServiceData, ResetSituationsConfigsApiServiceResponse, ResetSituationsConfigsApiServiceError, InitializeAccountApiServiceData, InitializeAccountApiServiceResponse, InitializeAccountApiServiceError, IdentifyTopicsApiServiceData, IdentifyTopicsApiServiceResponse, IdentifyTopicsApiServiceError, GenerateQuestionsApiServiceData, GenerateQuestionsApiServiceResponse, GenerateQuestionsApiServiceError, ProposePostApiServiceData, ProposePostApiServiceResponse, ProposePostApiServiceError, UpdatePersonalDataApiServiceData, UpdatePersonalDataApiServiceResponse, UpdatePersonalDataApiServiceError, ResetPersonalDataApiServiceData, ResetPersonalDataApiServiceResponse, UpdatePrintSettingsApiServiceData, UpdatePrintSettingsApiServiceResponse, UpdatePrintSettingsApiServiceError, ResetPrintSettingsApiServiceData, ResetPrintSettingsApiServiceResponse, GrabWebsiteApiServiceData, GrabWebsiteApiServiceResponse, GrabWebsiteApiServiceError, AreThoughtsReflectedApiServiceData, AreThoughtsReflectedApiServiceResponse, AreThoughtsReflectedApiServiceError, GenerateResumeApiServiceData, GenerateResumeApiServiceError, RetrieveEmbeddingApiServiceData, RetrieveEmbeddingApiServiceResponse, RetrieveEmbeddingApiServiceError, LinkTelegramApiServiceData, LinkTelegramApiServiceResponse, ChatProfileApiRagData, ChatProfileApiRagResponse, ChatProfileApiRagError, LoadKnowledgeApiRagData, LoadKnowledgeApiRagResponse, LoadKnowledgeApiRagError, ClearRagApiRagData, ClearRagApiRagResponse, ClearRagApiRagError, GetMeiliUserTokenApiStorageData, GetMeiliUserTokenApiStorageResponse, InitMeiliUserDataApiStorageData, InitMeiliUserDataApiStorageResponse, InitMeiliUserDataApiStorageError, DeleteMeiliUserDataApiStorageData, DeleteMeiliUserDataApiStorageResponse, SsotApiStorageSsotData, SsotApiStorageSsotResponse, MeiliHealthCheckApiStorageData, MeiliHealthCheckApiStorageResponse, CheckIndexApiStorageData, CheckIndexApiStorageResponse, SetupMeiliForProductionApiStorageData, SetupMeiliForProductionApiStorageResponse, MasterClearMeiliStorageApiStorageData, MasterClearMeiliStorageApiStorageResponse, MasterClearMeiliStorageApiStorageError, MasterReconfigureMeiliStorageApiStorageData, MasterReconfigureMeiliStorageApiStorageResponse, MasterReconfigureMeiliStorageApiStorageError, MasterReloadMeiliStorageApiStorageData, MasterReloadMeiliStorageApiStorageResponse, MasterReloadMeiliStorageApiStorageError, SetupMeiliEmbedderApiStorageData, SetupMeiliEmbedderApiStorageResponse, CheckMeiliEmbedderStatusApiStorageData, CheckMeiliEmbedderStatusApiStorageResponse, ResetMeiliEmbedderSetupApiStorageData, ResetMeiliEmbedderSetupApiStorageResponse, SearchMeiliWithQueryApiStorageData, SearchMeiliWithQueryApiStorageResponse, SearchMeiliWithQueryApiStorageError, StartPollingEndpointTelegramData, StartPollingEndpointTelegramResponse, StopPollingEndpointTelegramData, StopPollingEndpointTelegramResponse, WebhookTelegramData, SetupWebhookTelegramData, SetupWebhookTelegramResponse, ProtectedResourceRootAliasData } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Root
 */
export const root = <ThrowOnError extends boolean = false>(options?: Options<RootData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/',
        ...options
    });
};

/**
 * List Heroes Api
 * List static hero records for LLM/testing only.
 */
export const listHeroesApiTestingOnly = <ThrowOnError extends boolean = false>(options?: Options<ListHeroesApiTestingOnlyData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListHeroesApiTestingOnlyResponse, unknown, ThrowOnError>({
        url: '/heroes/',
        ...options
    });
};

/**
 * Create Hero Api
 * Create a new hero in the database.
 */
export const createHeroApiTestingOnly = <ThrowOnError extends boolean = false>(options: Options<CreateHeroApiTestingOnlyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateHeroApiTestingOnlyResponse, CreateHeroApiTestingOnlyError, ThrowOnError>({
        url: '/heroes/',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ssot
 * Exposes models to the openapi.json schema so that client SDK generators can build ts-types.
 */
export const ssotSsotSsot = <ThrowOnError extends boolean = false>(options?: Options<SsotSsotSsotData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SsotSsotSsotResponse, unknown, ThrowOnError>({
        url: '/ssot/expose_types',
        ...options
    });
};

/**
 * Get Mindstring Prototypes Api
 * Return backend-owned user-facing metadata for mindstring prototypes.
 */
export const getMindstringPrototypesApiSsotSsot = <ThrowOnError extends boolean = false>(options?: Options<GetMindstringPrototypesApiSsotSsotData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMindstringPrototypesApiSsotSsotResponse, unknown, ThrowOnError>({
        url: '/ssot/mindstring_prototypes',
        ...options
    });
};

/**
 * Health Check
 * Check if FastAPI is available and return system health information.
 */
export const healthCheckHealth = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/health/',
        ...options
    });
};

/**
 * Post Origin Api
 * HTTP adapter for creating a new origin.
 */
export const postOriginApiCrud = <ThrowOnError extends boolean = false>(options: Options<PostOriginApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostOriginApiCrudResponse, PostOriginApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/origin/post_origin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Origins Api
 * HTTP adapter for retrieving origins.
 */
export const getOriginsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetOriginsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetOriginsApiCrudResponse, GetOriginsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/origin/get_origins',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Origin Api
 * HTTP adapter for updating an origin.
 */
export const putOriginApiCrud = <ThrowOnError extends boolean = false>(options: Options<PutOriginApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutOriginApiCrudResponse, PutOriginApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/origin/put_origin',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Origins Api
 * HTTP adapter for bulk origin deletion.
 */
export const deleteOriginsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteOriginsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteOriginsApiCrudResponse, DeleteOriginsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/origin/delete_origins',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Post Situation Api
 * HTTP adapter for creating a new situation.
 */
export const postSituationApiCrud = <ThrowOnError extends boolean = false>(options: Options<PostSituationApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostSituationApiCrudResponse, PostSituationApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/situation/post_situation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Situations Api
 * HTTP adapter for retrieving situations.
 */
export const getSituationsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetSituationsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetSituationsApiCrudResponse, GetSituationsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/situation/get_situations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Situation Api
 * HTTP adapter for updating a situation.
 */
export const putSituationApiCrud = <ThrowOnError extends boolean = false>(options: Options<PutSituationApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutSituationApiCrudResponse, PutSituationApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/situation/put_situation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Situations Api
 * HTTP adapter for removing/deactivating situations.
 */
export const deleteSituationsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteSituationsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteSituationsApiCrudResponse, DeleteSituationsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/situation/delete_situations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Thoughts Api
 * HTTP adapter for retrieving thoughts.
 */
export const getThoughtsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetThoughtsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetThoughtsApiCrudResponse, GetThoughtsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/thought/get_thoughts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ingest Thoughts Api
 * HTTP adapter for batch thought ingestion.
 */
export const ingestThoughtsApiCrud = <ThrowOnError extends boolean = false>(options: Options<IngestThoughtsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestThoughtsApiCrudResponse, IngestThoughtsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/thought/ingest_thoughts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Confirm Thoughts Api
 * HTTP adapter for confirming thoughts.
 */
export const confirmThoughtsApiCrud = <ThrowOnError extends boolean = false>(options: Options<ConfirmThoughtsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ConfirmThoughtsApiCrudResponse, ConfirmThoughtsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/thought/confirm_thoughts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Thoughts Api
 * HTTP adapter for deleting/deactivating thoughts.
 */
export const deleteThoughtsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteThoughtsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteThoughtsApiCrudResponse, DeleteThoughtsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/thought/delete_thoughts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Targets Api
 * HTTP adapter for retrieving targets.
 */
export const getTargetsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetTargetsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetTargetsApiCrudResponse, GetTargetsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/target/get_targets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Post Target Api
 * HTTP adapter for creating a target and scheduling criteria extraction.
 */
export const postTargetApiCrud = <ThrowOnError extends boolean = false>(options: Options<PostTargetApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostTargetApiCrudResponse, PostTargetApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/target/post_target',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Target Api
 * HTTP adapter for updating target metadata/content.
 */
export const putTargetApiCrud = <ThrowOnError extends boolean = false>(options: Options<PutTargetApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutTargetApiCrudResponse, PutTargetApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/target/put_target',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Targets Api
 * HTTP adapter for deleting/deactivating targets.
 */
export const deleteTargetsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteTargetsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTargetsApiCrudResponse, DeleteTargetsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/target/delete_targets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Profile Api
 * HTTP adapter for retrieving authenticated profile.
 */
export const getProfileApiCrud = <ThrowOnError extends boolean = false>(options?: Options<GetProfileApiCrudData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetProfileApiCrudResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/profile/get_profile',
        ...options
    });
};

/**
 * Get Active Users Api
 * HTTP adapter for retrieving active users list.
 */
export const getActiveUsersApiCrud = <ThrowOnError extends boolean = false>(options?: Options<GetActiveUsersApiCrudData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetActiveUsersApiCrudResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/profile/get_active_users',
        ...options
    });
};

/**
 * Get Roles Api
 * HTTP adapter for retrieving authenticated user's roles.
 */
export const getRolesApiCrud = <ThrowOnError extends boolean = false>(options?: Options<GetRolesApiCrudData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetRolesApiCrudResponse, GetRolesApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/profile/get_roles',
        ...options
    });
};

/**
 * Get Moveon Api
 * HTTP adapter for retrieving public MoveOn view by token.
 */
export const getMoveonApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetMoveonApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetMoveonApiCrudResponse, GetMoveonApiCrudError, ThrowOnError>({
        url: '/moveon/get_moveon/{public_token}',
        ...options
    });
};

/**
 * Get Topics Api
 * HTTP adapter for retrieving identified topics.
 */
export const getTopicsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetTopicsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetTopicsApiCrudResponse, GetTopicsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/topic/get_topics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ingest Topics Api
 * HTTP adapter for ingesting identified topics.
 */
export const ingestTopicsApiCrud = <ThrowOnError extends boolean = false>(options: Options<IngestTopicsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestTopicsApiCrudResponse, IngestTopicsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/topic/ingest_topics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Topic Api
 * HTTP adapter for updating a topic.
 */
export const putTopicApiCrud = <ThrowOnError extends boolean = false>(options: Options<PutTopicApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutTopicApiCrudResponse, PutTopicApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/topic/put_topic',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Topics Api
 * HTTP adapter for deleting/deactivating topics.
 */
export const deleteTopicsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteTopicsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTopicsApiCrudResponse, DeleteTopicsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/topic/delete_topics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Criteria Api
 * HTTP adapter for retrieving criteria.
 */
export const getCriteriaApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetCriteriaApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetCriteriaApiCrudResponse, GetCriteriaApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/criterion/get_criteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ingest Criteria Api
 * HTTP adapter for batch criterion ingestion.
 */
export const ingestCriteriaApiCrud = <ThrowOnError extends boolean = false>(options: Options<IngestCriteriaApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestCriteriaApiCrudResponse, IngestCriteriaApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/criterion/ingest_criteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Criteria Api
 * HTTP adapter for deleting/deactivating criteria.
 */
export const deleteCriteriaApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteCriteriaApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCriteriaApiCrudResponse, DeleteCriteriaApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/criterion/delete_criteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Versions Api
 * HTTP adapter for retrieving versions.
 */
export const getVersionsApiCrud = <ThrowOnError extends boolean = false>(options: Options<GetVersionsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetVersionsApiCrudResponse, GetVersionsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/version/get_versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Post Version Api
 * HTTP adapter for creating a version.
 */
export const postVersionApiCrud = <ThrowOnError extends boolean = false>(options: Options<PostVersionApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PostVersionApiCrudResponse, PostVersionApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/version/post_version',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Put Version Api
 * HTTP adapter for updating a version.
 */
export const putVersionApiCrud = <ThrowOnError extends boolean = false>(options: Options<PutVersionApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<PutVersionApiCrudResponse, PutVersionApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/version/put_version',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Extend Version Api
 * HTTP adapter for extending a version.
 */
export const extendVersionApiCrud = <ThrowOnError extends boolean = false>(options: Options<ExtendVersionApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExtendVersionApiCrudResponse, ExtendVersionApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/version/extend_version',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Versions Api
 * HTTP adapter for deleting/deactivating versions.
 */
export const deleteVersionsApiCrud = <ThrowOnError extends boolean = false>(options: Options<DeleteVersionsApiCrudData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteVersionsApiCrudResponse, DeleteVersionsApiCrudError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/version/delete_versions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Expose Types Api
 * Expose ManageVersionMode type in OpenAPI for SDK generation.
 */
export const exposeTypesApiCrudSsot = <ThrowOnError extends boolean = false>(options?: Options<ExposeTypesApiCrudSsotData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ExposeTypesApiCrudSsotResponse, unknown, ThrowOnError>({
        url: '/version/expose_types',
        ...options
    });
};

/**
 * Extract Thoughts Api
 * HTTP adapter for thought extraction from source material.
 */
export const extractThoughtsApiService = <ThrowOnError extends boolean = false>(options: Options<ExtractThoughtsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExtractThoughtsApiServiceResponse, ExtractThoughtsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/extract_thoughts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Extract Criteria Api
 * HTTP adapter for criteria extraction from target content.
 */
export const extractCriteriaApiService = <ThrowOnError extends boolean = false>(options: Options<ExtractCriteriaApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExtractCriteriaApiServiceResponse, ExtractCriteriaApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/extract_criteria',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create Assessment Feedback Api
 * HTTP adapter for archiving thought-question mismatch feedback.
 */
export const createAssessmentFeedbackApiService = <ThrowOnError extends boolean = false>(options: Options<CreateAssessmentFeedbackApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateAssessmentFeedbackApiServiceResponse, CreateAssessmentFeedbackApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/assessment-feedback',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Create Feedback Collection Api
 * HTTP adapter for creating a public feedback collection link.
 */
export const createFeedbackCollectionApiService = <ThrowOnError extends boolean = false>(options: Options<CreateFeedbackCollectionApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateFeedbackCollectionApiServiceResponse, CreateFeedbackCollectionApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/feedback/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Revoke Feedback Collection Api
 * HTTP adapter for revoking public feedback collection links.
 */
export const revokeFeedbackCollectionApiService = <ThrowOnError extends boolean = false>(options: Options<RevokeFeedbackCollectionApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RevokeFeedbackCollectionApiServiceResponse, RevokeFeedbackCollectionApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/feedback/revoke',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * List Feedback Collection Links Api
 * HTTP adapter for listing public feedback collection link records.
 */
export const listFeedbackCollectionLinksApiService = <ThrowOnError extends boolean = false>(options?: Options<ListFeedbackCollectionLinksApiServiceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListFeedbackCollectionLinksApiServiceResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/feedback/links',
        ...options
    });
};

/**
 * Get Public Feedback Form Api
 * HTTP adapter for resolving public feedback form metadata.
 */
export const getPublicFeedbackFormApiService = <ThrowOnError extends boolean = false>(options: Options<GetPublicFeedbackFormApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetPublicFeedbackFormApiServiceResponse, GetPublicFeedbackFormApiServiceError, ThrowOnError>({
        url: '/service/feedback/{token}',
        ...options
    });
};

/**
 * Submit Public Feedback Api
 * HTTP adapter for public feedback submission.
 */
export const submitPublicFeedbackApiService = <ThrowOnError extends boolean = false>(options: Options<SubmitPublicFeedbackApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubmitPublicFeedbackApiServiceResponse, SubmitPublicFeedbackApiServiceError, ThrowOnError>({
        url: '/service/feedback/{token}/submit',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Transcribe Public Feedback Api
 * HTTP adapter for token-gated public feedback audio transcription.
 */
export const transcribePublicFeedbackApiService = <ThrowOnError extends boolean = false>(options: Options<TranscribePublicFeedbackApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TranscribePublicFeedbackApiServiceResponse, TranscribePublicFeedbackApiServiceError, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/service/feedback/{token}/transcribe',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Interpret Thought Api
 * HTTP adapter for thought interpretation V1.
 */
export const interpretThoughtApiExperiment = <ThrowOnError extends boolean = false>(options?: Options<InterpretThoughtApiExperimentData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<InterpretThoughtApiExperimentResponse, InterpretThoughtApiExperimentError, ThrowOnError>({
        url: '/experiment/interpret_thought',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Ocr Businesscard Api
 * Experimental OCR endpoint that returns a generated VCF file.
 */
export const ocrBusinesscardApiExperiment = <ThrowOnError extends boolean = false>(options: Options<OcrBusinesscardApiExperimentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, OcrBusinesscardApiExperimentError, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/experiment/ocr_businesscard',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Ocr Businesscard Data Api
 * Experimental OCR endpoint that returns the parsed business card contact.
 */
export const ocrBusinesscardDataApiExperiment = <ThrowOnError extends boolean = false>(options: Options<OcrBusinesscardDataApiExperimentData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OcrBusinesscardDataApiExperimentResponse, OcrBusinesscardDataApiExperimentError, ThrowOnError>({
        ...formDataBodySerializer,
        url: '/experiment/ocr_businesscard_data',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Ssot
 * Exposes the schema for BusinessCardContact to openapi.json so that client SDK generators can build types.
 * NOTE: Not meant to be called. It does not matter what is returned. Imporant is to mention the models in the response_model.
 */
export const ssotExperimentSsot = <ThrowOnError extends boolean = false>(options?: Options<SsotExperimentSsotData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SsotExperimentSsotResponse, unknown, ThrowOnError>({
        url: '/experiment/expose_types',
        ...options
    });
};

/**
 * Ocr Image Api
 * HTTP adapter for OCR text extraction from image/document uploads.
 */
export const ocrImageApiService = <ThrowOnError extends boolean = false>(options: Options<OcrImageApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OcrImageApiServiceResponse, OcrImageApiServiceError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/ocr_image',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Report Stats Api
 * HTTP adapter to generate report statistics for the authenticated user.
 */
export const reportStatsApiService = <ThrowOnError extends boolean = false>(options?: Options<ReportStatsApiServiceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<ReportStatsApiServiceResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/report_stats',
        ...options
    });
};

/**
 * Build Questionnaire Api
 * HTTP adapter for building a thought-reflection questionnaire.
 */
export const buildQuestionnaireApiService = <ThrowOnError extends boolean = false>(options: Options<BuildQuestionnaireApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BuildQuestionnaireApiServiceResponse, BuildQuestionnaireApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/build_questionnaire',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Set Reflection Api
 * HTTP adapter for setting a reflection score on a thought dimension.
 */
export const setReflectionApiService = <ThrowOnError extends boolean = false>(options: Options<SetReflectionApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SetReflectionApiServiceResponse, SetReflectionApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/set_reflection',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset Reflections Api
 * HTTP adapter for clearing one or all reflection dimensions.
 */
export const resetReflectionsApiService = <ThrowOnError extends boolean = false>(options: Options<ResetReflectionsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ResetReflectionsApiServiceResponse, ResetReflectionsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/reset_reflections',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Transcribe uploaded audio for review
 * Accepts an uploaded audio file, validates it, and returns transcribed text plus input metadata. This endpoint is intentionally pure and does not create an origin.
 */
export const transcribeAudioApiService = <ThrowOnError extends boolean = false>(options: Options<TranscribeAudioApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TranscribeAudioApiServiceResponse, TranscribeAudioApiServiceError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/transcribe_audio',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Upload Origin Api
 * HTTP adapter for uploaded-origin parsing and persistence.
 */
export const uploadOriginApiService = <ThrowOnError extends boolean = false>(options: Options<UploadOriginApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadOriginApiServiceResponse, UploadOriginApiServiceError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/upload_origin',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Update Situation Config Api
 * HTTP adapter for updating one or more situation configurations.
 */
export const updateSituationConfigApiService = <ThrowOnError extends boolean = false>(options: Options<UpdateSituationConfigApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateSituationConfigApiServiceResponse, UpdateSituationConfigApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/update_situation_config',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset Situations Configs Api
 * HTTP adapter for resetting multiple situation configurations.
 */
export const resetSituationsConfigsApiService = <ThrowOnError extends boolean = false>(options: Options<ResetSituationsConfigsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ResetSituationsConfigsApiServiceResponse, ResetSituationsConfigsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/reset_situations_configs',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Initialize Account Api
 * HTTP adapter for resume parsing and initial account population.
 */
export const initializeAccountApiService = <ThrowOnError extends boolean = false>(options: Options<InitializeAccountApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InitializeAccountApiServiceResponse, InitializeAccountApiServiceError, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/initialize_account',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Identify Topics Api
 * HTTP adapter for identifying publishable topics from origin content.
 */
export const identifyTopicsApiService = <ThrowOnError extends boolean = false>(options: Options<IdentifyTopicsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IdentifyTopicsApiServiceResponse, IdentifyTopicsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/identify_topics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Generate Questions Api
 * HTTP adapter for generating reflective publish-thought questions.
 */
export const generateQuestionsApiService = <ThrowOnError extends boolean = false>(options: Options<GenerateQuestionsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateQuestionsApiServiceResponse, GenerateQuestionsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/generate_questions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Propose Post Api
 * HTTP adapter for proposing a post from origin content and topic selection.
 */
export const proposePostApiService = <ThrowOnError extends boolean = false>(options: Options<ProposePostApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ProposePostApiServiceResponse, ProposePostApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/propose_post',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Update Personal Data Api
 * HTTP adapter for updating personal data.
 */
export const updatePersonalDataApiService = <ThrowOnError extends boolean = false>(options: Options<UpdatePersonalDataApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePersonalDataApiServiceResponse, UpdatePersonalDataApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/update_personal_data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset Personal Data Api
 * HTTP adapter for resetting personal data.
 */
export const resetPersonalDataApiService = <ThrowOnError extends boolean = false>(options?: Options<ResetPersonalDataApiServiceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<ResetPersonalDataApiServiceResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/reset_personal_data',
        ...options
    });
};

/**
 * Update Print Settings Api
 * HTTP adapter for updating print settings.
 */
export const updatePrintSettingsApiService = <ThrowOnError extends boolean = false>(options: Options<UpdatePrintSettingsApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdatePrintSettingsApiServiceResponse, UpdatePrintSettingsApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/update_print_settings',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Reset Print Settings Api
 * HTTP adapter for resetting print settings.
 */
export const resetPrintSettingsApiService = <ThrowOnError extends boolean = false>(options?: Options<ResetPrintSettingsApiServiceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).put<ResetPrintSettingsApiServiceResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/reset_print_settings',
        ...options
    });
};

/**
 * Grab Website Api
 * HTTP adapter for website scraping and origin persistence.
 */
export const grabWebsiteApiService = <ThrowOnError extends boolean = false>(options: Options<GrabWebsiteApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GrabWebsiteApiServiceResponse, GrabWebsiteApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/grab_website',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Are Thoughts Reflected Api
 * HTTP adapter for checking whether selected thoughts are fully reflected.
 */
export const areThoughtsReflectedApiService = <ThrowOnError extends boolean = false>(options: Options<AreThoughtsReflectedApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AreThoughtsReflectedApiServiceResponse, AreThoughtsReflectedApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/are_thoughts_reflected',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Generate Resume Api
 * HTTP adapter for resume generation and file streaming.
 */
export const generateResumeApiService = <ThrowOnError extends boolean = false>(options: Options<GenerateResumeApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, GenerateResumeApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/generate_resume',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Retrieve Embedding Api
 * HTTP adapter for retrieving a target content vector.
 */
export const retrieveEmbeddingApiService = <ThrowOnError extends boolean = false>(options: Options<RetrieveEmbeddingApiServiceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetrieveEmbeddingApiServiceResponse, RetrieveEmbeddingApiServiceError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/retrieve_embedding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Link Telegram Api
 * HTTP adapter for generating a Telegram deep link for account linking.
 */
export const linkTelegramApiService = <ThrowOnError extends boolean = false>(options?: Options<LinkTelegramApiServiceData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LinkTelegramApiServiceResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/service/link_telegram',
        ...options
    });
};

/**
 * Chat Profile Api
 */
export const chatProfileApiRag = <ThrowOnError extends boolean = false>(options: Options<ChatProfileApiRagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ChatProfileApiRagResponse, ChatProfileApiRagError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rag/chat_profile',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Load Knowledge Api
 */
export const loadKnowledgeApiRag = <ThrowOnError extends boolean = false>(options: Options<LoadKnowledgeApiRagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoadKnowledgeApiRagResponse, LoadKnowledgeApiRagError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rag/load_knowledge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Clear Rag Api
 */
export const clearRagApiRag = <ThrowOnError extends boolean = false>(options: Options<ClearRagApiRagData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClearRagApiRagResponse, ClearRagApiRagError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/rag/clear_rag',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Get Meili User Token Api
 */
export const getMeiliUserTokenApiStorage = <ThrowOnError extends boolean = false>(options?: Options<GetMeiliUserTokenApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetMeiliUserTokenApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/get_meili_user_token',
        ...options
    });
};

/**
 * Init Meili User Data Api
 */
export const initMeiliUserDataApiStorage = <ThrowOnError extends boolean = false>(options: Options<InitMeiliUserDataApiStorageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InitMeiliUserDataApiStorageResponse, InitMeiliUserDataApiStorageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/init_meili_user_data',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options?.headers
        }
    });
};

/**
 * Delete Meili User Data Api
 */
export const deleteMeiliUserDataApiStorage = <ThrowOnError extends boolean = false>(options?: Options<DeleteMeiliUserDataApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<DeleteMeiliUserDataApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/delete_meili_user_data',
        ...options
    });
};

/**
 * Ssot Api
 * Expose Meilisearch-related schemas to OpenAPI for client generation.
 */
export const ssotApiStorageSsot = <ThrowOnError extends boolean = false>(options?: Options<SsotApiStorageSsotData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SsotApiStorageSsotResponse, unknown, ThrowOnError>({
        url: '/meili/expose_types',
        ...options
    });
};

/**
 * Meili Health Check Api
 */
export const meiliHealthCheckApiStorage = <ThrowOnError extends boolean = false>(options?: Options<MeiliHealthCheckApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MeiliHealthCheckApiStorageResponse, unknown, ThrowOnError>({
        url: '/meili/meili_health_check',
        ...options
    });
};

/**
 * Check Index Api
 */
export const checkIndexApiStorage = <ThrowOnError extends boolean = false>(options?: Options<CheckIndexApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckIndexApiStorageResponse, unknown, ThrowOnError>({
        url: '/meili/check_index',
        ...options
    });
};

/**
 * Setup Meili For Production Api
 */
export const setupMeiliForProductionApiStorage = <ThrowOnError extends boolean = false>(options?: Options<SetupMeiliForProductionApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SetupMeiliForProductionApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/setup_meili_for_production',
        ...options
    });
};

/**
 * Master Clear Meili Storage Api
 */
export const masterClearMeiliStorageApiStorage = <ThrowOnError extends boolean = false>(options?: Options<MasterClearMeiliStorageApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<MasterClearMeiliStorageApiStorageResponse, MasterClearMeiliStorageApiStorageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/master_clear_meili_storage',
        ...options
    });
};

/**
 * Master Reconfigure Meili Storage Api
 */
export const masterReconfigureMeiliStorageApiStorage = <ThrowOnError extends boolean = false>(options?: Options<MasterReconfigureMeiliStorageApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<MasterReconfigureMeiliStorageApiStorageResponse, MasterReconfigureMeiliStorageApiStorageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/master_reconfigure_meili_storage',
        ...options
    });
};

/**
 * Master Reload Meili Storage Api
 */
export const masterReloadMeiliStorageApiStorage = <ThrowOnError extends boolean = false>(options?: Options<MasterReloadMeiliStorageApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<MasterReloadMeiliStorageApiStorageResponse, MasterReloadMeiliStorageApiStorageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/master_reload_meili_storage',
        ...options
    });
};

/**
 * Setup Meili Embedder Api
 */
export const setupMeiliEmbedderApiStorage = <ThrowOnError extends boolean = false>(options?: Options<SetupMeiliEmbedderApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SetupMeiliEmbedderApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/setup_meili_embedder',
        ...options
    });
};

/**
 * Check Meili Embedder Status Api
 */
export const checkMeiliEmbedderStatusApiStorage = <ThrowOnError extends boolean = false>(options?: Options<CheckMeiliEmbedderStatusApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CheckMeiliEmbedderStatusApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/check_meili_embedder_status',
        ...options
    });
};

/**
 * Reset Meili Embedder Setup Api
 */
export const resetMeiliEmbedderSetupApiStorage = <ThrowOnError extends boolean = false>(options?: Options<ResetMeiliEmbedderSetupApiStorageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<ResetMeiliEmbedderSetupApiStorageResponse, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/reset_meili_embedder_setup',
        ...options
    });
};

/**
 * Search Meili With Query Api
 */
export const searchMeiliWithQueryApiStorage = <ThrowOnError extends boolean = false>(options: Options<SearchMeiliWithQueryApiStorageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchMeiliWithQueryApiStorageResponse, SearchMeiliWithQueryApiStorageError, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/meili/search_meili_with_query',
        ...options
    });
};

/**
 * Start Polling Endpoint
 * Start bot in polling mode (for local development).
 */
export const startPollingEndpointTelegram = <ThrowOnError extends boolean = false>(options?: Options<StartPollingEndpointTelegramData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StartPollingEndpointTelegramResponse, unknown, ThrowOnError>({
        url: '/telegram/start-polling',
        ...options
    });
};

/**
 * Stop Polling Endpoint
 * Stop polling mode.
 */
export const stopPollingEndpointTelegram = <ThrowOnError extends boolean = false>(options?: Options<StopPollingEndpointTelegramData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<StopPollingEndpointTelegramResponse, unknown, ThrowOnError>({
        url: '/telegram/stop-polling',
        ...options
    });
};

/**
 * Webhook
 * Handle Telegram webhook requests.
 */
export const webhookTelegram = <ThrowOnError extends boolean = false>(options?: Options<WebhookTelegramData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
        url: '/telegram/webhook',
        ...options
    });
};

/**
 * Setup Webhook
 * Configure the Telegram bot webhook for receiving updates.
 */
export const setupWebhookTelegram = <ThrowOnError extends boolean = false>(options?: Options<SetupWebhookTelegramData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SetupWebhookTelegramResponse, unknown, ThrowOnError>({
        url: '/telegram/setup_webhook',
        ...options
    });
};

/**
 * Protected Resource Root Alias
 */
export const protectedResourceRootAlias = <ThrowOnError extends boolean = false>(options?: Options<ProtectedResourceRootAliasData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
        url: '/.well-known/oauth-protected-resource',
        ...options
    });
};